import { useCustomerStore } from '@/store/customerStore'
import { useDocumentStore } from '@/store/documentStore'
import { useUserStore } from '@/store/userStore'
import { usePaymentStore } from '@/store/paymentStore'
import { useSessionStore } from '@/store/sessionStore'
import { useAuthStore } from '@/store/authStore'
import { useAuditStore } from '@/store/auditStore'

/** Clear both in-memory and persisted tenant data across account/scope boundaries. */
export function clearAccountData() {
  useAuthStore.getState().resetStore()
  useCustomerStore.getState().resetStore()
  useDocumentStore.getState().resetStore()
  useUserStore.getState().resetStore()
  usePaymentStore.getState().resetStore()
  useSessionStore.getState().resetStore()
  useAuditStore.getState().resetStore()
  for (const key of [
    'taxhive-customer-store',
    'taxhive-document-store',
    'taxhive-user-store',
    'taxhive-payment-store',
    'taxhive-auth-store',
  ]) {
    localStorage.removeItem(key)
    sessionStorage.removeItem(key)
  }
  window.dispatchEvent(new Event('taxhive:account-changed'))
}
